import { useJpMode } from '@/lib/jpMode';
import { formatJpNumber } from '@/lib/jp-format';

/**
 * Renders a number under the user's chosen JP-mode unit:
 *   • plain  → 1,234,567
 *   • unit   → 1.23百万 (千 / 百万 / 億)
 *   • wide   → １,２３４,５６７ (full-width)
 *
 * Pass `decimals` for unit-mode precision (default 2).
 */
export function JpNumber({ value, decimals }: { value: number; decimals?: number }) {
  const { numericUnit } = useJpMode();
  return <span>{formatJpNumber(value, { mode: numericUnit, decimals })}</span>;
}
